import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext.jsx";
import api from "../../services/api.js";
import "./style.css";
import Logo from "../../assets/LOGOTIPO.png";
import toast from "react-hot-toast";

function AuthPage() {
  const [mode, setMode] = useState("login");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { updateLogin } = useAppContext();

  // LOGIN
  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);

    const form = new FormData(e.target);
    const usuario = form.get("usuario");

    try {
      const response = await api.get("v1/login", {
        params: {
          email: usuario
        }
      });

      const data = response.data;

      if (data.bloqueado === "S") {
        toast.error("Seu período de teste terminou");
        navigate("/assinatura");
        return;
      }

      updateLogin({
        codusuario: data.codusuarioapp,
        codusuarionuvem: data.codusuario,
        nome: data.nome,
        cpf: data.cpf,
        token: data.token,
        trial: data.trial,
        saldovisivel: data.saldovisivel,
        statusconta: data.statusconta,
        trialfim: data.trialfim,
        assinaturafim: data.assinaturafim
      });

      navigate("/principal");
    } catch (err) {
      toast.error("Usuário não encontrado");
    } finally {
      setLoading(false);
    }
  }

  // CRIAR CONTA
  async function handleRegister(e) {
    e.preventDefault();
    setLoading(true);

    const form = new FormData(e.target);

    const payload = {
      codusuario: 0,
      codusuarionuvem: 0,
      email: form.get("email"),
      nome: form.get("nome"),
      cpf: form.get("cpf"),
      whatsapp: form.get("whatsapp"),
      trial: "S",
      saldovisivel: "S"
    };

    try {
      const response = await api.post("v1/recebeusuario", payload);

      const data = response.data;

      updateLogin({
        codusuario: data.codusuarioapp,
        codusuarionuvem: data.codusuario,
        nome: data.nome,
        cpf: data.cpf,
        token: data.token,
        trial: "S",
        saldovisivel: "S",
        statusconta: "trial"
      });

      toast.success("Conta criada com sucesso!");

      navigate("/principal");
    } catch (err) {
      toast.error("Erro ao criar conta");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-wrapper">

        <div className="auth-header text-center">
          <div className="auth-logo">
            <img src={Logo} alt="" />
          </div>

          <h1>iContas</h1>

          <p>
            {mode === "login"
              ? "Organize hoje. Conquiste amanhã."
              : "Comece sua organização financeira hoje."}
          </p>
        </div>

        <div className="auth-card">

          {mode === "login" ? (
            <>
              <h4 className="mb-4">
                <i className="fa-solid fa-envelope me-2"></i>
                Acesso
              </h4>

              <form onSubmit={handleLogin}>

                <div className="mb-3">
                  <input
                    name="usuario"
                    type="email"
                    className="form-control"
                    placeholder="Email para acessar"
                    required
                  />
                </div>

                <button
                  className="btn btn-gradient w-100"
                  disabled={loading}
                >
                  {loading ? "Autenticando..." : "Acessar"}
                </button>

              </form>

              <div className="text-center mt-3 small">
                Não tem conta?{" "}
                <span
                  className="link-switch"
                  onClick={() => setMode("register")}
                >
                  Criar conta
                </span>
              </div>
            </>
          ) : (
            <>
              <h4 className="mb-4">
                <i className="fa-solid fa-user-plus me-2"></i>
                Criar Conta
              </h4>

              <form onSubmit={handleRegister}>

                <div className="mb-3">
                  <input
                    name="email"
                    type="email"
                    className="form-control"
                    placeholder="Seu email"
                    required
                  />
                </div>

                <div className="mb-3">
                  <input
                    name="nome"
                    type="text"
                    className="form-control"
                    placeholder="Seu nome"
                    required
                  />
                </div>

                <div className="mb-3">
                  <input
                    name="cpf"
                    type="number"
                    className="form-control"
                    placeholder="Seu CPF"
                    required
                  />
                </div>

                <div className="mb-3">
                  <input
                    name="whatsapp"
                    type="tel"
                    className="form-control"
                    placeholder="WhatsApp"
                  />
                </div>

                <button
                  className="btn btn-gradient w-100"
                  disabled={loading}
                >
                  {loading ? "Criando conta..." : "Criar minha conta"}
                </button>

              </form>

              <div className="text-center mt-3 small">
                Já possui conta?{" "}
                <span
                  className="link-switch"
                  onClick={() => setMode("login")}
                >
                  Entrar
                </span>
              </div>
            </>
          )}
        </div>

        <div className="version">0.0.1</div>

      </div>
    </div>
  );
}

export default AuthPage;